import Swiper from "swiper/bundle";
import "swiper/css/bundle";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".flex-layout.procedure-layout").forEach((layout) => {
        const swiperEl = layout.querySelector(".procedure-swiper");
        if (!swiperEl || swiperEl.querySelectorAll(".swiper-slide").length < 2) return;

        new Swiper(swiperEl, {
            slidesPerView: "auto",
            spaceBetween: 16,
            slideToClickedSlide: true,
            navigation: {
                prevEl: layout.querySelector(".swiper-button-prev-custom"),
                nextEl: layout.querySelector(".swiper-button-next-custom"),
                disabledClass: "is-disabled",
            },
            pagination: {
                el: layout.querySelector(".procedure-pagination"),
                clickable: true,
                bulletClass: "procedure-bullet",
                bulletActiveClass: "is-active",
                renderBullet: (index, className) => `<button type="button" class="${className}">${index + 1}</button>`,
            },
            keyboard: { enabled: true, onlyInViewport: true },
            a11y: {
                enabled: true,
                prevSlideMessage: "Vorige stap",
                nextSlideMessage: "Volgende stap",
                paginationBulletMessage: "Ga naar stap {{index}}",
                slideLabelMessage: "Stap {{index}} van {{slidesLength}}",
            },
            breakpoints: {
                768: { spaceBetween: 24 },
            },
        });
    });
});
